export default "__VITE_ASSET__DDlAc0YK__"